export default __webpack_public_path__ + "static/media/mypay-light.e43e8384.png";